export type ShotTypeTactical = (typeof ShotTypeTactical)[keyof typeof ShotTypeTactical];

export const ShotTypeTactical = {
  UNKNOWN: 'UNKNOWN',
  FREE_THROW: 'FREE_THROW',
  CATCH_AND_SHOOT: 'CATCH_AND_SHOOT',
  OFF_THE_DRIBBLE: 'OFF_THE_DRIBBLE',
} as const;

export function isShotTypeTactical(arg: unknown): arg is ShotTypeTactical {
  return Object.values(ShotTypeTactical).includes(arg as ShotTypeTactical);
}

export function isShotTypeTacticalArray(arg: unknown): arg is ShotTypeTactical[] {
  return Array.isArray(arg) && arg.every(isShotTypeTactical);
}
